<div class="formalize-widget" [ngClass]="{ 'expanded': isExpanded }">
  <div class="formalize-card" [ngClass]="{ 'expanded': isExpanded }">
    <div class="formalize-header text-white p-4" 
      (click)="toggleExpand()"
      [ngClass]="{ 'expanded mb-2': isExpanded }">
      <div class="pull-left">
        <i class="fas fa-magic formalize-icon"></i>
        <span class="formalize-title ml-3">AI Assistant</span>
      </div>
      <div class="pull-right">
        <i class="fa fa-chevron-right formalize-icon-chevron"></i>
      </div>
    </div>

    <div class="formalize-content-wrapper p-4 mb-3" [ngClass]="{ 'visible': isExpanded }">
      <!-- Selector and Button -->
      <div class="formalize-content left-col form-group mb-0 pl-0 col-xs-12">
        <ng-container *ngIf="emailMode">
          <div class="form-group" style="display:flex; align-items:center; margin-bottom:0.5rem">
            <label class="control-label">
              <input type="checkbox" class="subject-checkbox" [(ngModel)]="includeSubjectForEmail"> Include subject
            </label>
          </div>
        </ng-container>
        <label for="toneSelect" class="control-label mb-0 font-bold">Select Tone:</label>
        <div class="tone-selector-inline">
          <div class="tone-selector-wrapper-inline">
            <select
              id="toneSelect"
              [(ngModel)]="tone"
              class="tone-select inline-select"
              [disabled]="isLoading">
              <option value="Formal">Formal</option>
              <option value="Professional">Professional</option>
              <option value="Executive">Executive</option>
              <option value="Conversational">Conversational</option>
              <option value="Friendly">Friendly</option>
              <option value="Casual">Casual</option>
            </select>
            <i class="fa fa-chevron-down tone-select-icon"></i>
          </div>

          <!-- Email mode: show email-specific controls -->
          <ng-container *ngIf="emailMode; else normalMode">
            <div class="d-flex">
              <div style="display:flex; align-items:center; margin-left:0.5rem">
                <button class="formalize-button inline-button ml-3" (click)="formalizeEmail()" [disabled]="isLoading || isSuccess"
                  [ngClass]="{ 'is-loading': isLoading, 'is-success': isSuccess }">
                  <span *ngIf="!isLoading && !isSuccess" class="button-text">
                    <i class="fa fa-magic"></i>
                    <span class="button-label">E-nhance Email</span>
                  </span>
                  <span *ngIf="isLoading" class="button-text loading">
                    <i class="fa fa-spinner fa-spin"></i>
                    <span class="button-label">Enhancing...</span>
                  </span>
                  <span *ngIf="isSuccess" class="button-text success">
                    <i class="fa fa-check"></i>
                    <span class="button-label">Done!</span>
                  </span>
                </button>
              </div>
            </div>
          </ng-container>

          <ng-template #normalMode>
            <div class="d-flex align-items-center justify-content-start">
              <button class="formalize-button inline-button ml-3" (click)="formalize()"
                [disabled]="isLoading || !inputText || !inputText.trim() || isSuccess" [ngClass]="{
                            'is-loading': isLoading,
                            'is-success': isSuccess
                          }">
                <span *ngIf="!isLoading && !isSuccess" class="button-text">
                  <i class="fa fa-magic"></i>
                  <span class="button-label">Enhance Text</span>
                </span>
                <span *ngIf="isLoading" class="button-text loading">
                  <i class="fa fa-spinner fa-spin"></i>
                  <span class="button-label">Processing...</span>
                </span>
                <span *ngIf="isSuccess" class="button-text success">
                  <i class="fa fa-check"></i>
                  <span class="button-label">Done!</span>
                </span>
              </button>
            </div>
          </ng-template>
        </div>

        <!-- Feedback messages below buttons -->
        <div *ngIf="isSuccess" class="formalize-feedback success-feedback mt-1">
          <i class="fa fa-check-circle"></i>
          <p class="mb-0">{{ emailMode ? 'Email Successfully Enhanced' : 'Text Successfully Enhanced' }}</p>
        </div>
        <div *ngIf="isError" class="formalize-feedback error-feedback ml-2">
          <i class="fa fa-exclamation-circle"></i>
          <p class="mb-0">{{ errorMessage }}</p>
        </div>
    </div>

  </div>
</div>
